export function toggleExclusiveFilterValue(currentValues, nextValue) {
  const normalizedValues = Array.isArray(currentValues) ? currentValues : [];
  if (normalizedValues.includes(nextValue)) {
    return normalizedValues.filter((item) => item !== nextValue);
  }

  return [nextValue];
}

export function normalizeExclusiveFilterInput(rawValue) {
  const normalizedValues = typeof rawValue === 'string'
    ? rawValue.split(',')
    : (Array.isArray(rawValue) ? rawValue : []);

  const compactValues = normalizedValues
    .map((value) => String(value || '').trim())
    .filter(Boolean);

  return compactValues.length > 0 ? [compactValues[compactValues.length - 1]] : [];
}

export function normalizeMultiSelectInput(rawValue) {
  const normalizedValues = typeof rawValue === 'string'
    ? rawValue.split(',')
    : (Array.isArray(rawValue) ? rawValue : []);

  return normalizedValues
    .map((value) => String(value || '').trim())
    .filter(Boolean);
}

export function toggleMultiFilterValue(currentValues, nextValue) {
  const normalizedValues = Array.isArray(currentValues) ? currentValues : [];
  if (normalizedValues.includes(nextValue)) {
    return normalizedValues.filter((item) => item !== nextValue);
  }

  return [...normalizedValues, nextValue];
}